module.exports = __webpack_public_path__ + "static/media/emailBlack.f1b85519.svg";